import type { FaireProductEntity } from "../../entity_types/product";

export const p_g2ax3jg22v: FaireProductEntity = {
  token: "p_g2ax3jg22v",
  type: "product",
  name: "Magnesium",
  brandToken: "b_2k3t71ozhd",
  brandName: "Arrae",
  imageUrl:
    "https://cdn.faire.com/fastly/f2fbc0e5bd9bb38bcc2b625eab3e56787faa54f86f07e0ee9c75fc06fe2cb78d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e2f3256994629a99a1fd3adbed30f1c5103c7dd0864eadc007d684b53f194ad7.png",
  ],
  priceDollars: 24,
  description:
    "Our revolutionary Magnesium blend is the only one like it on the market - combining the most bioavailable high-quality magnesium at the correct dosages for optimal function. Take 3 capsules daily either at morning or night - whenever works for you, so you can feel great anywhere!\n\n- Eliminates stress and anxiety\n- Helps you fall asleep and stay asleep\n- Relieves headaches and migraines\n- Reduces muscle cramps and tension\n- Improves focus, mood and memory\n- Superior absorption for fast-acting results\n- All-natural and clinically studied",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:45.956Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
